<template>
  <span v-html="formatted"></span>
</template>

<script>
import formatPrice from '../../helpers/formatPrice';

export default {
  props: {
    price: Number,
  },

  computed: {
    formatted() {
      if (typeof this.price === 'undefined' || !this.price || Number.isNaN(this.price)) {
        return '-';
      }

      return formatPrice(this.price, 2);
    },
  },
};
</script>
